export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGOUT = "LOGOUT";
//EMPTY TABLE DATA
export const EMPTY_TABLE_DATA = "EMPTY_TABLE_DATA";

//USERS
export const USERS_TABLE_DATA_START = "USERS_TABLE_DATA_START";
export const USERS_TABLE_DATA_SUCCESS = "USERS_TABLE_DATA_SUCCESS";
export const USERS_TABLE_DATA_FAILED = "USERS_TABLE_DATA_FAILED";

//DESIGNATION
export const DESIGNATION_TABLE_DATA_START = "DESIGNATION_TABLE_DATA_START";
export const DESIGNATION_TABLE_DATA_SUCCESS = "DESIGNATION_TABLE_DATA_SUCCESS";
export const DESIGNATION_TABLE_DATA_FAILED = "DESIGNATION_TABLE_DATA_FAILED";

//TOOLS
export const TOOLS_TABLE_DATA_START = "TOOLS_TABLE_DATA_START";
export const TOOLS_TABLE_DATA_SUCCESS = "TOOLS_TABLE_DATA_SUCCESS";
export const TOOLS_TABLE_DATA_FAILED = "TOOLS_TABLE_DATA_FAILED";

//RESPONSIBILITY
export const RESPONSIBILITY_TABLE_DATA_START = "RESPONSIBILITYS_TABLE_DATA_START";
export const RESPONSIBILITY_TABLE_DATA_SUCCESS = "RESPONSIBILITY_TABLE_DATA_SUCCESS";
export const RESPONSIBILITY_TABLE_DATA_FAILED = "RESPONSIBILITY_TABLE_DATA_FAILED";
//USERS
export const PROJECT_TABLE_DATA_START = "PROJECT_TABLE_DATA_START";
export const PROJECT_TABLE_DATA_SUCCESS = "PROJECT_TABLE_DATA_SUCCESS";
export const PROJECT_TABLE_DATA_FAILED = "PROJECT_TABLE_DATA_FAILED";

//TECHNOLOGY
export const TECHNOLOGY_TABLE_DATA_START = "TECHNOLOGY_TABLE_DATA_START";
export const TECHNOLOGY_TABLE_DATA_SUCCESS = "TECHNOLOGY_TABLE_DATA_SUCCESS";
export const TECHNOLOGY_TABLE_DATA_FAILED = "TECHNOLOGY_TABLE_DATA_FAILED";

//FRAMEWORK
export const FRAMEWORK_TABLE_DATA_START = "FRAMEWORK_TABLE_DATA_START";
export const FRAMEWORK_TABLE_DATA_SUCCESS = "FRAMEWORK_TABLE_DATA_SUCCESS";
export const FRAMEWORK_TABLE_DATA_FAILED = "FRAMEWORK_TABLE_DATA_FAILED";

//IDE
export const IDE_TABLE_DATA_START = "IDE_TABLE_DATA_START";
export const IDE_TABLE_DATA_SUCCESS = "IDE_TABLE_DATA_SUCCESS";
export const IDE_TABLE_DATA_FAILED = "IDE_TABLE_DATA_FAILED";

//VERSION_CONTROL_SYSTEM
export const VERSION_CONTROL_TABLE_DATA_START = "VERSION_CONTROL_TABLE_DATA_START";
export const VERSION_CONTROL_TABLE_DATA_SUCCESS = "VERSION_CONTROL_TABLE_DATA_SUCCESS";
export const VERSION_CONTROL_TABLE_DATA_FAILED = "VERSION_CONTROL_TABLE_DATA_FAILED";

//WEB_SERVICES
export const WEB_SERVICES_TABLE_DATA_START = "WEB_SERVICES_TABLE_DATA_START";
export const WEB_SERVICES_TABLE_DATA_SUCCESS = "WEB_SERVICES_TABLE_DATA_SUCCESS";
export const WEB_SERVICES_TABLE_DATA_FAILED = "WEB_SERVICES_TABLE_DATA_FAILED";

//OTHER_SKILLS
export const OTHER_SKILLS_TABLE_DATA_START = "OTHER_SKILLS_TABLE_DATA_START";
export const OTHER_SKILLS_TABLE_DATA_SUCCESS = "OTHER_SKILLS_TABLE_DATA_SUCCESS";
export const OTHER_SKILLS_TABLE_DATA_FAILED = "OTHER_SKILLS_TABLE_DATA_FAILED";

//OPERATING_SYSTEMS
export const OPERATING_SYSTEMS_TABLE_DATA_START = "OPERATING_SYSTEMS_TABLE_DATA_START";
export const OPERATING_SYSTEMS_TABLE_DATA_SUCCESS = "OPERATING_SYSTEMS_TABLE_DATA_SUCCESS";
export const OPERATING_SYSTEMS_TABLE_DATA_FAILED = "OPERATING_SYSTEMS_TABLE_DATA_FAILED";

//GOOGLE_COMPONENTS
export const GOOGLE_COMPONENTS_TABLE_DATA_START = "GOOGLE_COMPONENTS_TABLE_DATA_START";
export const GOOGLE_COMPONENTS_TABLE_DATA_SUCCESS = "GOOGLE_COMPONENTS_TABLE_DATA_SUCCESS";
export const GOOGLE_COMPONENTS_TABLE_DATA_FAILED = "GOOGLE_COMPONENTS_TABLE_DATA_FAILED";

//APP_SETTING
export const APP_SETTING_TABLE_DATA_START = "APP_SETTING_TABLE_DATA_START";
export const APP_SETTING_TABLE_DATA_SUCCESS = "APP_SETTING_TABLE_DATA_SUCCESS";
export const APP_SETTING_TABLE_DATA_FAILED = "APP_SETTING_TABLE_DATA_FAILED";


//DASHBOARD_COUNT
export const DASHBOARD_COUNT_TABLE_DATA_START = "DASHBOARD_COUNT_TABLE_DATA_START";
export const DASHBOARD_COUNT_TABLE_DATA_SUCCESS = "DASHBOARD_COUNT_TABLE_DATA_SUCCESS";
export const DASHBOARD_COUNT_TABLE_DATA_FAILED = "DASHBOARD_COUNT_TABLE_DATA_FAILED";

//VENDOR
export const VENDOR_TABLE_DATA_START = "VENDOR_TABLE_DATA_START";
export const VENDOR_TABLE_DATA_SUCCESS = "VENDOR_TABLE_DATA_SUCCESS";
export const VENDOR_TABLE_DATA_FAILED = "VENDOR_TABLE_DATA_FAILED";


//CREATED_CV
export const CREATED_CV_DATA_START = "CREATED_CV_DATA_START";
export const CREATED_CV_DATA_SUCCESS = "CREATED_CV_DATA_SUCCESS";
export const CREATED_CV_DATA_FAILED = "CREATED_CV_DATA_FAILED";
